import { useState } from "react";
import { Product } from "../types/restaurant";

export const useOrderManagement = () => {
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const [discount, setDiscount] = useState<number>(0);
  const [deliveryFee, setDeliveryFee] = useState<number>(0);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editingProduct, setEditingProduct] = useState<string | null>(null);
  const [editedAmount, setEditedAmount] = useState<string>("");
  const [editingNote, setEditingNote] = useState<string | null>(null);

  const calculateSubtotal = (): number => {
    return selectedProducts.reduce((acc, order) => {
      const amount = parseFloat(order.Amount) || 0;
      return acc + order.quantity * amount;
    }, 0);
  };

  const calculateTotal = (subtotal: number, isDelivery: boolean = true): number => {
  // Only add delivery fee if it’s a delivery order
  return subtotal - discount + (isDelivery ? deliveryFee : 0);
};


  const handleAddToOrder = (foodItem: Product) => {
    setSelectedProducts((prev) => {
      const existingOrder = prev.find((order) => order._id.$oid === foodItem._id.$oid);

      if (existingOrder) {
        return prev.map((order) => (order._id.$oid === foodItem._id.$oid ? { ...order, quantity: order.quantity + 1 } : order));
      }

      return [...prev, { ...foodItem, quantity: 1 }];
    });
  };

  const handleIncrement = (foodItem: Product) => {
    setSelectedProducts((prev) => {
      const existingOrder = prev.find((order) => order._id.$oid === foodItem._id.$oid);

      if (existingOrder) {
        return prev.map((order) => (order._id.$oid === foodItem._id.$oid ? { ...order, quantity: order.quantity + 1 } : order));
      }

      return [...prev, { ...foodItem, quantity: 1 }];
    });
  };

  const handleDecrement = (foodItem: Product) => {
    setSelectedProducts((prev) => {
      const existingOrder = prev.find((order) => order._id.$oid === foodItem._id.$oid);

      if (!existingOrder) return prev;

      if (existingOrder.quantity > 1) {
        return prev.map((order) => (order._id.$oid === foodItem._id.$oid ? { ...order, quantity: order.quantity - 1 } : order));
      }

      return prev.filter((order) => order._id.$oid !== foodItem._id.$oid);
    });
  };

  const deleteProduct = (id: string) => {
    const updatedProducts = selectedProducts.filter((item) => item._id.$oid !== id);
    setSelectedProducts(updatedProducts);
  };

  const handleNoteChange = (orderId: string, note: string) => {
    setSelectedProducts((prevProducts) => prevProducts.map((item) => (item._id.$oid === orderId ? { ...item, notes: note } : item)));
  };

  return {
    selectedProducts,
    setSelectedProducts,
    discount,
    setDiscount,
    deliveryFee,
    setDeliveryFee,
    isEditing,
    setIsEditing,
    editingProduct,
    setEditingProduct,
    editedAmount,
    setEditedAmount,
    editingNote,
    setEditingNote,
    calculateSubtotal,
    calculateTotal,
    handleAddToOrder,
    handleIncrement,
    handleDecrement,
    deleteProduct,
    handleNoteChange,
  };
};
